import React from 'react';
import { Button } from '../../ui/button';
import { CheckCircle2, XCircle, Mail, MapPin, AlertTriangle } from 'lucide-react';

const fmt = (d) => (d ? new Date(d).toLocaleDateString() : '—');
const URGENCY = { urgent: 'bg-red-500/20 text-red-300', soon: 'bg-amber-500/20 text-amber-300', normal: 'bg-slate-600/40 text-slate-300' };

function RealityCheck({ req }) {
  if (!req.account_exists) {
    return <p className="flex items-center gap-1 text-red-300 text-xs" data-testid="request-account-missing"><AlertTriangle className="h-3 w-3" /> Account no longer exists</p>;
  }
  return (
    <p className="text-xs text-slate-400" data-testid="request-reality-check">
      Member since {fmt(req.member_since)} · {req.families.length ? `In: ${req.families.join(', ')}` : 'Not in any family'}
    </p>
  );
}

export function RequestCard({ req, onAct }) {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-5 flex flex-col md:flex-row md:items-start gap-4" data-testid={`request-card-${req.request_id}`}>
      <div className="flex-1 space-y-2">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="text-white font-semibold">{req.specialty_label}</h3>
          {req.urgency && <span className={`text-xs px-2 py-0.5 rounded-full ${URGENCY[req.urgency] || URGENCY.normal}`}>{req.urgency}</span>}
          {req.status !== 'active' && <span className="text-xs px-2 py-0.5 rounded-full bg-slate-600 text-slate-200">{req.status}</span>}
        </div>
        <p className="flex items-center gap-1 text-slate-300 text-sm"><MapPin className="h-3.5 w-3.5" />{[req.city, req.region, req.country].filter(Boolean).join(', ')}</p>
        <p className="text-slate-200 text-sm">
          <span className="font-medium">{req.user_name}</span>
          {req.user_email && <a href={`mailto:${req.user_email}`} className="ml-2 inline-flex items-center gap-1 text-amber-400 hover:underline" data-testid="request-email-link"><Mail className="h-3.5 w-3.5" />{req.user_email}</a>}
        </p>
        <RealityCheck req={req} />
        {req.notes && <p className="text-slate-300 text-sm italic">"{req.notes}"</p>}
        <p className="text-xs text-slate-500">Requested {fmt(req.created_at)}</p>
      </div>
      {req.status === 'active' && (
        <div className="flex md:flex-col gap-2">
          <Button onClick={() => onAct(req, 'fulfill')} className="bg-green-600 hover:bg-green-700" data-testid="request-fulfill-btn">
            <CheckCircle2 className="h-4 w-4 mr-2" />Mark fulfilled
          </Button>
          <Button variant="outline" onClick={() => onAct(req, 'dismiss')} className="border-red-500/50 text-red-400 hover:bg-red-500/10 bg-transparent" data-testid="request-dismiss-btn">
            <XCircle className="h-4 w-4 mr-2" />Dismiss
          </Button>
        </div>
      )}
    </div>
  );
}
